// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export class TrialcardEscoordV1ModelsCaseDocumentRelationshipModel {
    'documentId'?: number;
    'comment'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TrialcardEscoordV1ModelsCaseDocumentRelationshipModel>> = [
        {
            "name":     "documentId",
            "baseName": "documentId",
            "type":     "number"
        },
        {
            "name":     "comment",
            "baseName": "comment",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TrialcardEscoordV1ModelsCaseDocumentRelationshipModel.attributeTypeMap;
    }
}
